import React from "react"

import BodyText from "./BodyText"
import CurvedTextContainer from "./CurvedTextContainer"
import { Element } from "legacy/components/shared/base"
import { Maybe } from "types/Maybe"
import { PrismicPageDataBodyCurvedText } from "types/__generated__/gatsby-graphql"
import { useTheme } from "src/legacy/utils"

interface OwnProps {
  data: Maybe<PrismicPageDataBodyCurvedText>
}

export type CurvedTextSectionProps = OwnProps

const CurvedTextSection: React.FC<CurvedTextSectionProps> = ({
  data,
}): React.ReactElement | null => {
  if (!data) return null

  const primary = data.primary
  const repeater = data.items
  const bgColor = primary?.background_color
  const { sizes } = useTheme()

  return (
    <Element bg={bgColor} p={["50px 30px", "50px 40px 85px", "85px 40px"]}>
      <Element margin="0 auto" maxWidth={sizes.contentWidth}>
        <Element
          display="flex"
          flexDirection={["column", "column", "column", "row"]}
        >
          <CurvedTextContainer curvedText={primary?.curved_text} />
          <BodyText bodyText={repeater} primary={primary} />
        </Element>
      </Element>
    </Element>
  )
}

export default CurvedTextSection
